import React, { useState } from 'react';
import { Card, Form, Space, Input } from 'antd';

import { RadioComponent, DataTypeSingleMulti, formItemLayout }from '../Common'
import { isEmpty, invalidURI } from 'script/common';

const FilterServer = ({t, apps, settingKey, settingData, onSave, alertMessage}) => {
	const [option, setOption] = useState(isEmpty(settingData.multi) ? true : false);
	const initialValues = {
		['option']: option,
		['single']: settingData.single,
		['multi']: settingData.multi
	}

	const onFinish = (e) => {
		const isSingle = (isEmpty(e.option)) ? false : e.option;
		let value = [];
		if (isSingle) {
			try {
				let defaultValue = initialValues.single.default
				let initValue = initialValues.single.value

				let setValue = e.single.value
				if (invalidURI(setValue)) return alertMessage("The URI format is incorrect.")

				value.push({
					key : settingKey.value,
					value: (defaultValue === setValue) ? null : setValue
				})

			} catch (error) {
			}
			
		} else {
			Object.keys(e.multi).forEach((app) => {
				let defaultValue = null
				let initValue = null;
				if (!isEmpty(initialValues.multi)) {
					defaultValue = (isEmpty(initialValues.multi[app])) ? null : initialValues.multi[app].default
					initValue = (isEmpty(initialValues.multi[app])) ? null : initialValues.multi[app].value
				}

				let setValue = isEmpty(e.multi[app].value) ? null : e.multi[app].value
				if (invalidURI(setValue)) return alertMessage("The URI format is incorrect.")

				value.push({
					key: settingKey.value + "_"+ app,
					value: (defaultValue === setValue) ? null : setValue
				})
			})
		}

		if (!isEmpty(value)) {
			onSave(isSingle, value)
		}
	}

	return (
		<Form {...formItemLayout} onFinish={onFinish} initialValues={initialValues}>
			<Card title={t(settingKey.key)} key={settingKey.key} style={{ margin: 20 }}>
				<RadioComponent
					t={t}
					option={option}
					setOption={setOption}
				/>
				<DataTypeSingleMulti
					t={t}
					label={'URI'}
					option={option}
					apps={apps}
					settingData={settingData}
				/>
				<Space style={{ float: 'right', margin: 20 }}>
					<button className="btn_text_b">{t('user.account.save')}</button>
				</Space>
			</Card>
		</Form>
	)
}

export default FilterServer